"use client";

import { useEffect } from "react";

type RecaptchaLoaderProps = {
  siteKey: string;
};

const RECAPTCHA_SCRIPT_ID = "recaptcha-enterprise-script";
const INTERACTION_EVENTS = ["pointerdown", "keydown", "touchstart", "scroll"] as const;
const FALLBACK_DELAY_MS = 6000;

export default function RecaptchaLoader({ siteKey }: Readonly<RecaptchaLoaderProps>) {
  useEffect(() => {
    if (document.getElementById(RECAPTCHA_SCRIPT_ID)) return;

    let loaded = false;

    const load = () => {
      if (loaded) return;
      loaded = true;

      cleanup();

      window.recaptchaOptions = { enterprise: true };

      const script = document.createElement("script");
      script.id = RECAPTCHA_SCRIPT_ID;
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`;
      script.async = true;
      document.head.appendChild(script);
    };

    const cleanup = () => {
      INTERACTION_EVENTS.forEach((event) => window.removeEventListener(event, load));
      window.clearTimeout(timeoutId);
    };

    INTERACTION_EVENTS.forEach((event) =>
      window.addEventListener(event, load, { once: true, passive: true }),
    );
    const timeoutId = window.setTimeout(load, FALLBACK_DELAY_MS);

    return cleanup;
  }, [siteKey]);

  return null;
}
